import { render, staticRenderFns } from "./UserMobile.vue?vue&type=template&id=641e300e&"
import script from "./UserMobile.vue?vue&type=script&lang=ts&"
export * from "./UserMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports